export default {
  computed: {
    $policyLocationsPayload() {
      if (this.$userData?.role === "superadmin") return null;
      const payload = this.$userData?.polices?.["see-models-register"]?.payload;
      return payload?.autologin || null;
    },
    $policyAllowedCityNames() {
      if (!this.$policyLocationsPayload) return null;
      return Object.keys(this.$policyLocationsPayload);
    },
    $policyIsLocked() {
      const payload = this.$policyLocationsPayload;
      if (!payload) return false;
      const cities = Object.keys(payload);
      if (cities.length !== 1) return false;
      const offices = payload[cities[0]] || [];
      return offices.length <= 1;
    },
  },
  methods: {
    $filterCitiesByPolicy(cities) {
      const allowed = this.$policyAllowedCityNames;
      if (!allowed) return cities;
      if (Array.isArray(cities)) {
        return cities.filter((c) => allowed.includes(c.cityName || c.name));
      }
      return Object.fromEntries(Object.entries(cities || {}).filter(([name]) => allowed.includes(name)));
    },
    $filterOfficesByPolicy(offices) {
      const payload = this.$policyLocationsPayload;
      if (!payload) return offices;
      return (offices || []).filter((office) => {
        const cityAllowed = payload[office.cityName];
        if (cityAllowed === undefined) return false;
        if (!cityAllowed.length) return true;
        return cityAllowed.includes(office.officeName);
      });
    },
  },
};
